export function currentPhase(calendar, transaction) {
    const phase = calendar.phases[transaction.getCalendarState(calendar).phaseIndex];
    if (!phase)
        throw new TypeError(`Calendar ${calendar.id} has an invalid phase index`);
    return phase;
}
export function runCalendars(transaction, definitions, stepMs, boundaryMs) {
    const ordered = [...definitions].sort((left, right) => left.id < right.id ? -1 : left.id > right.id ? 1 : 0);
    for (const calendar of ordered) {
        if (!transaction.isScopeActive(calendar.scope))
            continue;
        const state = transaction.getCalendarState(calendar);
        const phase = calendar.phases[state.phaseIndex];
        const elapsedMs = state.elapsedMs + stepMs;
        if (elapsedMs < phase.durationMs) {
            transaction.setCalendarState(calendar, { ...state, elapsedMs });
            continue;
        }
        const phaseIndex = (state.phaseIndex + 1) % calendar.phases.length;
        const cycle = phaseIndex === 0 ? state.cycle + 1n : state.cycle;
        const nextPhase = calendar.phases[phaseIndex];
        const sequence = (state.boundaries.at(-1)?.sequence ?? 0n) + 1n;
        transaction.setCalendarState(calendar, {
            phaseIndex,
            elapsedMs: elapsedMs - phase.durationMs,
            cycle,
            boundaries: [
                ...state.boundaries,
                Object.freeze({ sequence, phaseId: nextPhase.id, cycle, atGameMs: boundaryMs }),
            ],
        });
    }
}
//# sourceMappingURL=runtime.js.map